// Value-only enum used by paywall schemas. Kept separate from identsOverrides.ts
// so build-time tools (paywall-report.ts) can load paywall instances without
// pulling Pinia/Vue into Node — the runtime resolver in identsOverrides.ts depends on stores.
export enum IdentsOverrideId {
	ML_PRICE_DISCOUNT = 'ML_PRICE_DISCOUNT',
	ML_PRICE_PREMIUM = 'ML_PRICE_PREMIUM',
	// Premium arm gated on WTP derived from traffic source (UA channel) instead of currency.
	// Used by the web_ml_price_prediction_wtp_traffic_source_i3_1 experiment.
	ML_PRICE_PREMIUM_TRAFFIC_WTP = 'ML_PRICE_PREMIUM_TRAFFIC_WTP',
}
